import React, {useState} from "react";
import {connect, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import SvgDashboard from "../../iconComponents/IconDashboard";
import NotificationBar from "./NotificationBar";
import {useMediaQuery } from 'react-responsive';
import {toggleSidebar} from "../../../actions/core";


export function SidebarPageLink(props) {
    const core = useSelector((state) => state.core);
    const isTabletOrMobile = useMediaQuery({query: '(max-width: 768px)' });
    const Icon = props.icon;
    const sidebarIsOpen = (core.sidebarIsDefault && !isTabletOrMobile) || (!core.sidebarIsDefault && isTabletOrMobile)

    const handleSelect = () => {
        isTabletOrMobile && props.toggleSidebar();
    }

    return (
        <li id={props.id} className="sp-linkwrap" onClick={() => handleSelect()} >
            <Link to={props.path} className={core.sidebarActivePage === props.id ? "sp-link g2-text" : "sp-link g5-text"} >
                <div className="sp-linkclip" >
                    <Icon pathClass={core.sidebarActivePage === props.id ? "g3-fill" : "g55-fill"} className="sp-icon" height="22px"/>
                    <span className={sidebarIsOpen ? "sp-text" : "sp-text min"}>
                    {props.title}
                    </span>
                </div>
            </Link>
        </li>

    )
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, {toggleSidebar})(SidebarPageLink);

